const bodycertificatecontent = [
{id:0,
title:"Certificados",
img:"https://raw.githubusercontent.com/RamonFavero/ramonportfolio/main/src/img/udemy-certificate.jpg",
title2:"Certificado do Curso Full-Stack da Angela Yu:",
corpo:"Um curso 'all-in-one' com uma linguagem simples e fácil de entender com uma progressão para uma linguagem mais técnica conforme o curso vai se estendendo. Além de todos os ensinamentos técnicos que me foi fornecido, a coisa que mais aprecio neste bootcamp foi o foco em nos ensinar a ler documentação. Para toda linguagem, API ou site existe uma documentação oficial e confiável."
},
{id:1,
title:"Certificados",
img:"https://raw.githubusercontent.com/RamonFavero/ramonportfolio/main/src/img/udemy-certificate-python.jpg",
title2:"Certificado do Curso de Python do Maximilian Schwarzmüller:",
corpo:"Achei bastante gananciosa a ideia de ensinar blockchain como um primeiro projeto para um iniciante, mas logo percebi que os fundamentos da linguagem estavam todos sendo aplicados de forma exepcional! Devo destacar a aptidão do professor em aplicar gerenciamento de erros e introduzir o assunto de escalabilidade."
},
{id:2,
title:"Certificados",
img:"https://raw.githubusercontent.com/RamonFavero/ramonportfolio/main/src/img/udemy-certificate-math.jpg",
title2:"Certificado do Curso de Matemática por Rafael F.V.C. Santos, Ph.D.:",
corpo:"Curso livre completamente focado em toda matemática envolvida em Ciência de Dados, Conceitos gerais sobre funções matemáticas, Trigonometria, Função exponencial e muito mais."
}

]
export default bodycertificatecontent